import { render, staticRenderFns } from "./FAQPage.vue?vue&type=template&id=08540377&scoped=true&"
import script from "./FAQPage.vue?vue&type=script&lang=js&"
export * from "./FAQPage.vue?vue&type=script&lang=js&"
import style0 from "./FAQPage.vue?vue&type=style&index=0&id=08540377&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08540377",
  null
  
)

export default component.exports